import { makeStyles } from 'tss-react/mui';

export const useTargetConversionCellStyles = makeStyles()((theme) => ({
  content: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
    alignItems: 'center',
    columnGap: theme.spacing(2),
    rowGap: theme.spacing(0.5),
    maxWidth: 'min(400px, 90vw)',
    [theme.breakpoints.down('sm')]: {
      columnGap: theme.spacing(1),
      maxWidth: 'min(260px, 90vw)',
    },
  },
  status: {
    display: 'flex',
    alignItems: 'center',
  },
  amount: {
    textAlign: 'right',
  },
  updatedAt: {
    gridColumn: '1 / -1',
    justifySelf: 'end',
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
}));
